module.exports = __webpack_public_path__ + "img/neolicitador.217b3076.png";